import Reference from './reference.jsx'

export default class MCOWRA extends Reference {
  constructor (payment) {
    super(payment)
    this.displayName = 'MCOWRA Payment'
  }

  eligible () {
    return this.payment.booking.booking.paymentMethods.mcowra
  }

  book () {
    return this.payment.booking.payWithMCOWRA(
      this.payment.calculatePaymentAmount(),
      this.data.reference
    )
  }
}

